const BMM_DASHBOARD_MENU = {
  title: "Dashboard",
  route: "backupManagementDashboard",
  icon: "GridIcon",
}
const BMM_SERVER_MANAGEMENT_MENU = {
  title: "Server Management",
  route: "backupManagementServerManagement",
  icon: "ServerIcon",
}
const BMM_REPOSITORY_MENU = {
  title: "Repository",
  route: "backupManagementRepository",
  icon: "DatabaseIcon",
}
const BMM_BACKUP_MENU = {
  title: "Backup",
  route: "backupManagementBackup",
  icon: "UploadCloudIcon",
}
const BMM_CREDENTIAL_MENU = {
  title: "Credential",
  route: "backupManagementCredential",
  icon: "KeyIcon",
}

const BMM_VEEAM_MENU = {
  title: "Veeam Server",
  route: "backupManagementVeeam",
  icon: "HardDriveIcon",
}

export {
  BMM_DASHBOARD_MENU,
  BMM_SERVER_MANAGEMENT_MENU,
  BMM_REPOSITORY_MENU,
  BMM_BACKUP_MENU,
  BMM_CREDENTIAL_MENU,
  BMM_VEEAM_MENU,
}
